
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_939IjETzbFmQMeta } from "/home/node/app/rdp-eyebot/pages/[...slug].vue?macro=true";
import { default as alreadyRedeemedB820wWlpQ1Meta } from "/home/node/app/rdp-eyebot/pages/alreadyRedeemed.vue?macro=true";
import { default as _91_46_46_46slug_93TtPIupMI2TMeta } from "/home/node/app/rdp-eyebot/pages/amazon/[...slug].vue?macro=true";
import { default as alreadyRedeemedhV260N6wgkMeta } from "/home/node/app/rdp-eyebot/pages/amazon/alreadyRedeemed.vue?macro=true";
import { default as eyebot_45welcomeDqVmOSkV2JMeta } from "/home/node/app/rdp-eyebot/pages/amazon/eyebot-welcome.vue?macro=true";
import { default as eyebotAIxPyaQv5tMeta } from "/home/node/app/rdp-eyebot/pages/amazon/eyebot.vue?macro=true";
import { default as login_45errorEPVgDnPdvwMeta } from "/home/node/app/rdp-eyebot/pages/amazon/login-error.vue?macro=true";
import { default as loginQvffDXf6a0Meta } from "/home/node/app/rdp-eyebot/pages/amazon/login.vue?macro=true";
import { default as time_45outaaW2t5pyqYMeta } from "/home/node/app/rdp-eyebot/pages/amazon/time-out.vue?macro=true";
import { default as eyebot_45welcomezSuYdlL7vDMeta } from "/home/node/app/rdp-eyebot/pages/eyebot-welcome.vue?macro=true";
import { default as eyebotC1OIt4s9WCMeta } from "/home/node/app/rdp-eyebot/pages/eyebot.vue?macro=true";
import { default as index9TvgUVLE1JMeta } from "/home/node/app/rdp-eyebot/pages/index.vue?macro=true";
import { default as login_45error85obtLjLQuMeta } from "/home/node/app/rdp-eyebot/pages/login-error.vue?macro=true";
import { default as loginJofdtCNf6yMeta } from "/home/node/app/rdp-eyebot/pages/login.vue?macro=true";
import { default as page_45not_45foundrvAZjRZQNKMeta } from "/home/node/app/rdp-eyebot/pages/page-not-found.vue?macro=true";
import { default as employeeVirapJ6e93Meta } from "/home/node/app/rdp-eyebot/pages/terms-of-use/employee.vue?macro=true";
import { default as indexm1B2Vr8zdqMeta } from "/home/node/app/rdp-eyebot/pages/terms-of-use/employer/index.vue?macro=true";
import { default as v1CgNxCn80UrMeta } from "/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v1.vue?macro=true";
import { default as v2S1xYTmySfGMeta } from "/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v2.vue?macro=true";
import { default as v3JuIJyuICHHMeta } from "/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v3.vue?macro=true";
import { default as time_45out9bRbDHJHGnMeta } from "/home/node/app/rdp-eyebot/pages/time-out.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/node/app/rdp-eyebot/pages/[...slug].vue")
  },
  {
    name: "alreadyRedeemed",
    path: "/alreadyRedeemed",
    meta: alreadyRedeemedB820wWlpQ1Meta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/alreadyRedeemed.vue")
  },
  {
    name: "amazon-slug",
    path: "/amazon/:slug(.*)*",
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/[...slug].vue")
  },
  {
    name: "amazon-alreadyRedeemed",
    path: "/amazon/alreadyRedeemed",
    meta: alreadyRedeemedhV260N6wgkMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/alreadyRedeemed.vue")
  },
  {
    name: "amazon-eyebot-welcome",
    path: "/amazon/eyebot-welcome",
    meta: eyebot_45welcomeDqVmOSkV2JMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/eyebot-welcome.vue")
  },
  {
    name: "amazon-eyebot",
    path: "/amazon/eyebot",
    meta: eyebotAIxPyaQv5tMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/eyebot.vue")
  },
  {
    name: "amazon-login-error",
    path: "/amazon/login-error",
    meta: login_45errorEPVgDnPdvwMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/login-error.vue")
  },
  {
    name: "amazon-login",
    path: "/amazon/login",
    meta: loginQvffDXf6a0Meta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/login.vue")
  },
  {
    name: "amazon-time-out",
    path: "/amazon/time-out",
    meta: time_45outaaW2t5pyqYMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/amazon/time-out.vue")
  },
  {
    name: "eyebot-welcome",
    path: "/eyebot-welcome",
    meta: eyebot_45welcomezSuYdlL7vDMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/eyebot-welcome.vue")
  },
  {
    name: "eyebot",
    path: "/eyebot",
    meta: eyebotC1OIt4s9WCMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/eyebot.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/node/app/rdp-eyebot/pages/index.vue")
  },
  {
    name: "login-error",
    path: "/login-error",
    meta: login_45error85obtLjLQuMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/login-error.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginJofdtCNf6yMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/login.vue")
  },
  {
    name: "page-not-found",
    path: "/page-not-found",
    component: () => import("/home/node/app/rdp-eyebot/pages/page-not-found.vue")
  },
  {
    name: "terms and use",
    path: "/terms-of-use/employee",
    meta: employeeVirapJ6e93Meta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/terms-of-use/employee.vue")
  },
  {
    name: "terms and use employer",
    path: "/terms-of-use/employer",
    meta: indexm1B2Vr8zdqMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/terms-of-use/employer/index.vue")
  },
  {
    name: "terms and use employer v1",
    path: "/terms-of-use/employer/v1",
    meta: v1CgNxCn80UrMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v1.vue")
  },
  {
    name: "terms and use employer v2",
    path: "/terms-of-use/employer/v2",
    meta: v2S1xYTmySfGMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v2.vue")
  },
  {
    name: "terms and use employer v3",
    path: "/terms-of-use/employer/v3",
    meta: v3JuIJyuICHHMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/terms-of-use/employer/v3.vue")
  },
  {
    name: "time-out",
    path: "/time-out",
    meta: time_45out9bRbDHJHGnMeta || {},
    component: () => import("/home/node/app/rdp-eyebot/pages/time-out.vue")
  }
]